import React, {useState, useEffect} from 'react'
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button } from '@mui/material';
import { useMutation } from "react-query";
import apiClient from '../../request/http-common';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from 'react-redux';
import { setUser } from './userSlice';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAuthStatus, setToken } from '../../request/Auth/authSlice';
import { useQuery } from 'react-query';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Currency } from '@depay/local-currency';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import { Container, IconButton, InputAdornment } from '@mui/material';
import { 
  Visibility, 
  VisibilityOff, 
  Email, 
  Lock, 
  Person, 
  Phone, 
  LocationOn, 
  ArrowForward,
  Public,
  Search
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';

// Styled components for better visual hierarchy
const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: '16px',
  boxShadow: theme.palette.mode === 'dark' 
    ? '0 4px 16px rgba(0, 0, 0, 0.2)' 
    : '0 4px 16px rgba(0, 0, 0, 0.05)',
  border: theme.palette.mode === 'dark' 
    ? '1px solid rgba(255, 255, 255, 0.1)' 
    : '1px solid rgba(255, 255, 255, 0.8)',
  background: theme.palette.mode === 'dark' 
    ? 'rgba(30, 30, 30, 0.95)' 
    : 'rgba(255, 255, 255, 0.95)',
  overflow: 'visible',
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: '12px',
  padding: '12px 24px',
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'none',
  background: 'linear-gradient(135deg, #F7A600 0%, #FFB52E 100%)',
  boxShadow: '0 4px 15px rgba(247, 166, 0, 0.4)',
  '&:hover': {
    background: 'linear-gradient(135deg, #E69500 0%, #F7A600 100%)',
    boxShadow: '0 6px 20px rgba(247, 166, 0, 0.6)',
  },
}));

const StyledInput = styled(OutlinedInput)(({ theme }) => ({
  borderRadius: '12px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
    borderWidth: '2px',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#F7A600',
    borderWidth: '2px',
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  borderRadius: '12px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
    borderWidth: '2px',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#F7A600',
    borderWidth: '2px',
  },
}));

const Register = () => {
    const [countries, setCountries] = useState('');
    const { isLoading: isloadingCountries, refetch: getCountries } = useQuery(
        "countries",
        async () => {
          return await apiClient.get("/api/countries");
        },
        {
          enabled: true,
          onSuccess: (res) => {
            console.log('Countries API Response:', res.data);
            if (res.data.success === true) {
                setCountries(res.data.countries);
                console.log('Countries loaded:', res.data.countries);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

    const dispatch = useDispatch();
    const initialLogin = {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        phone: '',
        address: '',
        referral: '',
        country: ''

    }
   
    const [error, setErros] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [countrySearch, setCountrySearch] = useState('');
    const [openCountrySelect, setOpenCountrySelect] = useState(false);
    
    const [registerForm, setRegisterForm] = useState(initialLogin);
    const appMode = useSelector((state) => state.mode.mode);
    const redirectTo = useSelector((state) => state.redirect.redirect);
    const inviter = useSelector((state) => state.referrals.inviter);

    const navigate = useNavigate();

    const onChange = (e) =>
    setRegisterForm({ ...registerForm, [e.target.name]: e.target.value });

    const handleCountrySelect = (countryName) => {
        setRegisterForm({ ...registerForm, country: countryName });
        setCountrySearch('');
        setOpenCountrySelect(false);
    };

    const filteredCountries = countries && countries.length > 0 
        ? countries.filter(country => 
            country.name.toLowerCase().includes(countrySearch.toLowerCase())
          )
        : [];
    let currency = Currency.getCode();

    const { isLoading: isSendingRequest, mutate: postLogin } = useMutation(
        
        async () => {
          return await apiClient.post(`/api/register`, {
            name: registerForm.name,
            email: registerForm.email,
            password: registerForm.password,
            password_confirmation: registerForm.password_confirmation,
            phone: registerForm.phone,
            address: registerForm.address,
            referral: inviter,
            country: registerForm.country,
            currency: currency
          });
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('auth-token', res.data.access_token);
            dispatch(setUser(res.data.user));
            dispatch(setAuthStatus('authenticated'));
            dispatch(setToken(res.data.access_token));
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event2 = new Event('processed');
            window.dispatchEvent(event2);

            if (redirectTo !== '') {
                navigate(redirectTo);
            }else{
                window.location.href  = '/';
              }

          },
          onError: (err) => {   
            let myerror = err.response?.data || err;         
            setErros(myerror.errors)  
            const event2 = new Event('processed');
            window.dispatchEvent(event2);     
          },
        }
      );
      const onSubmit = async() =>{
        const event3 = new Event('processing');
        window.dispatchEvent(event3);
        postLogin();
      } 

      useEffect(() => {
        getCountries();
      }, []);

      // Close dropdown when clicking outside
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (openCountrySelect && !event.target.closest('.country-selector')) {
            setOpenCountrySelect(false);
            setCountrySearch('');
          }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [openCountrySelect]);

  return (
    <Box 
      sx={{ 
        minHeight: '100vh',
        background: appMode === 'dark' 
          ? 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%)'
          : 'linear-gradient(135deg, #F7A600 0%, #FFB52E 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xs: '10px', sm: '15px', md: '20px' }
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2, md: 3 }, overflow: 'visible' }}>
        <StyledCard sx={{ maxWidth: '1000px', mx: 'auto', overflow: 'visible' }}>
          <CardContent sx={{ p: { xs: 3, sm: 4, md: 5 }, overflow: 'visible' }}>
            {/* Logo Section */}
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <img  
                src={appMode === 'dark'? '/logos/imex-light-logo.png' : '/logos/imex-dark-logo.png'} 
                style={{height: '60px', marginBottom: '16px'}} 
                alt="IMEXS BROKERAGE Logo" 
              />
              <Typography 
                variant="h4" 
                sx={{ 
                  fontWeight: 700, 
                  background: 'linear-gradient(135deg, #F7A600 0%, #FFB52E 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  mb: 1
                }}
              >
                Create Account
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  color: 'text.secondary',
                  fontSize: '16px'
                }}
              >
                Join us and start your trading journey today
              </Typography>
            </Box>

            {/* Referral Alert */}
            {(inviter !== '' && inviter !== null) && (
              <Alert 
                severity="info" 
                sx={{ 
                  mb: 3, 
                  borderRadius: '12px',
                  '& .MuiAlert-icon': { fontSize: '20px' }
                }}
              >
                Your referral code is <strong>{inviter}</strong>
              </Alert>
            )}

            {/* Form Fields */}
            <Grid container spacing={3}>
              {/* Name Field */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="name"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#F7A600' }
                    }}
                  >
                    Full Name
                  </InputLabel>
                  <StyledInput
                    error={error !== '' && error.name}
                    onChange={onChange}
                    id="name"
                    name="name"
                    type="text"
                    label="Full Name"
                    startAdornment={
                      <InputAdornment position="start">
                        <Person sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                  />
                  {error !== '' && error.name && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.name}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Email Field */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="email"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#F7A600' }
                    }}
                  >
                    Email Address
                  </InputLabel>
                  <StyledInput
                    error={error !== '' && error.email}
                    onChange={onChange}
                    id="email"
                    type="email"
                    name="email"
                    label="Email Address"
                    startAdornment={
                      <InputAdornment position="start">
                        <Email sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                  />
                  {error !== '' && error.email && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.email}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Phone Field */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="phone"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#F7A600' }
                    }}
                  >
                    Phone Number
                  </InputLabel>
                  <StyledInput
                    error={error !== '' && error.phone}
                    onChange={onChange}
                    id="phone"
                    name="phone"
                    type="tel"
                    label="Phone Number"
                    startAdornment={
                      <InputAdornment position="start">
                        <Phone sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                  />
                  {error !== '' && error.phone && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.phone}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Country Field */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth sx={{ position: 'relative', zIndex: 1 }}>
                  <InputLabel 
                    htmlFor="country"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#F7A600' }
                    }}
                  >
                    Country
                  </InputLabel>
                  <Box sx={{ position: 'relative' }} className="country-selector">
                    <StyledInput
                      value={registerForm.country}
                      onClick={() => setOpenCountrySelect(true)}
                      readOnly
                      placeholder="Select Country"
                      startAdornment={
                        <InputAdornment position="start">
                          {registerForm.country && countries ? (
                            <img 
                              src={countries.find(c => c.name === registerForm.country)?.flag} 
                              alt="flag" 
                              style={{ width: '20px', height: '15px', marginRight: '8px', borderRadius: '2px' }}
                            />
                          ) : (
                            <Public sx={{ color: 'text.secondary', fontSize: '20px' }} />
                          )}
                        </InputAdornment>
                      }
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setOpenCountrySelect(!openCountrySelect)}
                            edge="end"
                            sx={{ color: 'text.secondary' }}
                          >
                            <ArrowForward sx={{ 
                              transform: openCountrySelect ? 'rotate(90deg)' : 'rotate(0deg)',
                              transition: 'transform 0.2s'
                            }} />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                    
                    {/* Custom Dropdown */}
                    {openCountrySelect && (
                      <Box sx={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        zIndex: 9999,
                        backgroundColor: appMode === 'dark' ? 'rgba(30, 30, 30, 0.95)' : 'rgba(255, 255, 255, 0.95)',
                        border: appMode === 'dark' ? '1px solid rgba(255, 255, 255, 0.2)' : '1px solid rgba(0, 0, 0, 0.1)',
                        borderRadius: '12px',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                        mt: 1,
                        maxHeight: '300px',
                        overflow: 'hidden',
                        backdropFilter: 'blur(10px)',
                      }}>
                        {/* Search Input */}
                        <Box sx={{ p: 2, borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                          <StyledInput
                            placeholder="Search countries..."
                            value={countrySearch}
                            onChange={(e) => setCountrySearch(e.target.value)}
                            startAdornment={
                              <InputAdornment position="start">
                                <Search sx={{ color: 'text.secondary', fontSize: '20px' }} />
                              </InputAdornment>
                            }
                            sx={{ 
                              '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                              '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
                            }}
                          />
                        </Box>
                        
                        {/* Countries List */}
                        <Box sx={{ maxHeight: '240px', overflowY: 'auto' }}>
                          {filteredCountries.length > 0 ? (
                            filteredCountries.map((country) => (
                              <Box
                                key={country.id}
                                onClick={() => handleCountrySelect(country.name)}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  p: 2,
                                  cursor: 'pointer',
                                  borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
                                  '&:hover': {
                                    backgroundColor: appMode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                  },
                                  '&:last-child': {
                                    borderBottom: 'none',
                                  }
                                }}
                              >
                                <img 
                                  src={country.flag} 
                                  alt={country.name}
                                  style={{ 
                                    width: '24px', 
                                    height: '18px', 
                                    marginRight: '12px', 
                                    borderRadius: '2px',
                                    objectFit: 'cover'
                                  }}
                                />
                                <Typography sx={{ 
                                  color: 'text.primary',
                                  fontSize: '14px',
                                  fontWeight: 500
                                }}>
                                  {country.name}
                                </Typography>
                              </Box>
                            ))
                          ) : (
                            <Box sx={{ p: 2, textAlign: 'center' }}>
                              <Typography sx={{ color: 'text.secondary', fontSize: '14px' }}>
                                {isloadingCountries ? 'Loading countries...' : 'No countries found'}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    )}
                  </Box>
                  
                  {error !== '' && error.country && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.country}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Address Field */}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="address"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#F7A600' }
                    }}
                  >
                    Address
                  </InputLabel>
                  <StyledInput
                    error={error !== '' && error.address}
                    onChange={onChange}
                    id="address"
                    name="address"
                    type="text"
                    label="Address"
                    startAdornment={
                      <InputAdornment position="start">
                        <LocationOn sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                  />
                  {error !== '' && error.address && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.address}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Password Field */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="password"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#F7A600' }
                    }}
                  >
                    Password
                  </InputLabel>
                  <StyledInput
                    error={error !== '' && error.password}
                    onChange={onChange}
                    id="password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    label="Password"
                    startAdornment={
                      <InputAdornment position="start">
                        <Lock sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                          sx={{ color: 'text.secondary' }}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  {error !== '' && error.password && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.password}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Confirm Password Field */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                    htmlFor="password_confirmation"
                    sx={{ 
                      color: 'text.secondary',
                      '&.Mui-focused': { color: '#F7A600' }
                    }}
                  >
                    Confirm Password
                  </InputLabel>
                  <StyledInput
                    error={error !== '' && error.password_confirmation}
                    onChange={onChange}
                    id="password_confirmation"
                    name="password_confirmation"
                    type={showConfirmPassword ? 'text' : 'password'}
                    label="Confirm Password"
                    startAdornment={
                      <InputAdornment position="start">
                        <Lock sx={{ color: 'text.secondary', fontSize: '20px' }} />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          edge="end"
                          sx={{ color: 'text.secondary' }}
                        >
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  {error !== '' && error.password_confirmation && (
                    <Typography color='error' sx={{ mt: 1, fontSize: '14px' }}>
                      {error.password_confirmation}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
            </Grid>

            {/* Action Links */}
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              mt: 4,
              mb: 3
            }}>
              <Typography variant="body2" sx={{ color: 'text.secondary', mr: 1 }}>
                Already have an account?
              </Typography>
                              <Link 
                  component={RouterLink} 
                  to='/login' 
                  underline="none"
                  sx={{ 
                    color: '#F7A600',
                    fontWeight: 500,
                    '&:hover': { textDecoration: 'underline' }
                  }}
                >
                Sign In
              </Link>
            </Box>

            {/* Submit Button */}
            <StyledButton
              onClick={onSubmit}
              fullWidth
              size="large"
              variant="contained"
              disabled={isSendingRequest}
              endIcon={isSendingRequest ? null : <ArrowForward />}
              sx={{ 
                height: '56px',
                fontSize: '16px',
                fontWeight: 600
              }}
            >
              {isSendingRequest ? 'Creating Account...' : 'Create Account'}
            </StyledButton>

            {/* Footer */}
            <Box sx={{ textAlign: 'center', mt: 4 }}>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'text.secondary',
                  fontSize: '14px'
                }}
              >
                By creating an account, you agree to our Terms of Service and Privacy Policy
              </Typography>
            </Box>
          </CardContent>
        </StyledCard>
      </Container>
    </Box>
  )
}

export default Register
